import { render, staticRenderFns } from "./HomeTopCollections2.vue?vue&type=template&id=126919c1&scoped=true"
import script from "./HomeTopCollections2.vue?vue&type=script&lang=js"
export * from "./HomeTopCollections2.vue?vue&type=script&lang=js"
import style0 from "./HomeTopCollections2.vue?vue&type=style&index=0&id=126919c1&prod&scoped=true&lang=css"
import style1 from "./HomeTopCollections2.vue?vue&type=style&index=1&id=126919c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126919c1",
  null
  
)

export default component.exports